import React from 'react';
import styles from './PageWrap.module.scss';

export default function PageWrap({noBottomPadding=false, children }) {
  return <div className={noBottomPadding ===false ? styles.wrap: styles.noBottomPadding}>{children}</div>;
}
